const CENTER = {
    left: '50%',
    transform: 'translateX(-50%)'
};
const popupBottomCenter = (index) => ({
    ...CENTER,
    bottom: 200,
    transform: `translate(-50%, calc(-${index} * 105%))`
});
const bottomCenter = (index) => ({
    ...CENTER,
    bottom: 100,
    transform: `translate(-50%, calc(-${index} * 105%))`
});
const topCenter = (index) => ({
    ...CENTER,
    top: 60,
    transform: `translate(-50%, calc(${index} * 105%))`
});
export const snackbarPosition = (index) => ({
    'top-center': topCenter(index),
    'bottom-center': bottomCenter(index),
    'popup-bottom-center': popupBottomCenter(index)
});
//# sourceMappingURL=position.js.map